module.exports = __webpack_public_path__ + "img/grey_romb_2.9094b28d.png";